import { useContext, useEffect } from "react";
import { SuccessIcon } from "./Icons";
import { ErrorIcon } from "./Icons";
import { FieldProps } from "../../types";
import { validators } from "../../languages";
import InputControl from "./InputControl";
import MainStateContext from "../../state/mainStateContext";

export function AddressLine1Field(props: FieldProps) {
  const { formMethods, fieldClasses, inputWrapperClasses, inputClasses, disabled } = props;
  const { setValueChange } = formMethods;

  const { state } = useContext(MainStateContext);
  const { address } = state;

  useEffect(() => {
    setValueChange("address1", address.line1);
  }, [address.line1]);

  return (
    <InputControl
      fieldId="address1"
      fieldName="address1"
      fieldTitlePhraseKey="payment_step.field_labels.address1"
      fieldType="text"
      fieldValue={address.line1}
      fieldClasses={fieldClasses}
      inputWrapperClasses={inputWrapperClasses}
      inputClasses={inputClasses}
      labelClasses={"is-required sr-only"}
      formMethods={formMethods}
      attributes={{
        disabled: disabled,
        autoCorrect: "off",
        autoComplete: "address-line1",
        autocapitalize: "off",
        spellcheck: "false"
      }}
      errorIcon={<ErrorIcon />}
      successIcon={<SuccessIcon />}
      validators={[validators.required, validators.invalidChars, validators.maxLength(50)]}
    />
  );
}

export default AddressLine1Field;
